import React from "react";
import "../assets/css/talhacss/webinarSearch.css";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Loader from "react-loader-spinner";
import { urlImageUrl } from "../config/urlapi";
import Moment from "react-moment";
import ReactPaginate from "react-paginate";
import $ from "jquery";
import { connect } from "react-redux";
import FuzzySearch from "fuzzy-search";
import {
  getAllPublishedWebinars,
  getWebinarByType,
  getInstructors,
  getWebinarCount,
  // Add this action to get categories
  getWebinarCategories,
} from "../redux/admin/webinar/webinarActions";
import Select from "react-select";
import CpdActivitiesSIDEbar from "./CpdActivitiesSIDEbar";
import ReactTooltip from "react-tooltip";
import { reverse } from "lodash";

const colourStyles = {
  control: (styles) => ({ ...styles, border: "1px solid black" }),
};

class WebinarSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      data1: [],
      currentSelected: [],
      webinartype: "Live Webinar",
      webinarName: "Live Webinar By PEC",
      elements: [],
      perPage: 12,
      currentPage: 0,
      loading: true,
      search: "",
      SelectedInstructor: { value: "", label: "All" },
      SelectedCategory: { value: "", label: "All Categories" }, // New category state
      dateSort: "",
      InstructorSet: [],
      CategorySet: [], // New category options array
      result: [],
      data: [
        {
          name: "CPD Short Courses and Training",
          url: "/CpdShortCourse",
        },
        {
          name: "Webinars",
          url: "",
          type: "button",
          child: [
            {
              name: "Live Webinars By PEC",
              url: "/WebinarSearch/livewebinar",
            },
          ],
        },
        {
          name: "Online Courses",
          url: "/onlineCourse",
        },
        {
          name: "Engineer's CPD Profile",
          url: "Ecp",
          type: "button",
          child: [
            {
              name: " CPD Profile",
              url: "/CpdProfile",
            },
            {
              name: "Calculator of CPD Points",
              url: "/CalculatorofCPD",
            },
          ],
        },
      ],
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.setState(
        {
          search: "",
          SelectedInstructor: { value: "", label: "All" },
          selectedInstructor: { value: "", label: "All" },
          SelectedCategory: { value: "", label: "All Categories" }, // Reset category filter
          dateSort: "",
        },
        () => {
          if (this.props.match.params.id == "livewebinar") {
            this.setState(
              {
                webinartype: "Live Webinar",
                webinarName: "Live Webinar By PEC",
              },
              () => {
                this.getCountbyType();
              }
            );
          }
        }
      );
    }
  }

  getWebinarsbyType = () => {
    let data = {
      webinartype: this.state.webinartype,
      OffSet: this.state.perPage * this.state.currentPage,
    };
    console.log(this.state.webinartype);
    this.props.getAllPublishedWebinars(data).then((res) => {
      console.log("inside get WebinarType Function....", res);
      this.setState(
        {
          data1: res,
          result: res,
          loading: false,
        },
        () => {
          let currentSelected = [];
          for (let i = 0; i < this.state.data1.length; i++) {
            currentSelected.push(this.state.data1[i]);
          }
          this.setState(
            { result: currentSelected, currentSelected: currentSelected },
            () => {
              this.setElementsForCurrentPage();
            }
          );
        }
      );
    });
  };

  getCountbyType = () => {
    this.props
      .getWebinarCount(this.state.webinartype)
      .then((res) => {
        this.setState(
          {
            pageCount: Math.ceil(res[0].count / this.state.perPage),
          },
          () => {
            this.getWebinarsbyType();
          }
        );
      })
      .catch((err) => console.log(err));
  };

  componentDidMount() {
    document.title = "Webinar Search";
    window.scrollTo(0, 0);
    
    this.props.getAllPublishedWebinars();
    
    // Load instructors
    this.props.getInstructors().then((res) => {
      console.log("getAllInstructors...", res.length);
      var temp = [];
      temp.push({ value: "", label: "All" });
      for (var i = 0; i < res.length; i++) {
        var obj = { value: res[i].FullName, label: res[i].FullName };
        temp.push(obj);
      }
      this.setState({ InstructorSet: temp });
    });

    // Load categories - You'll need to implement this action
    // Assuming you have a getWebinarCategories action
    if (this.props.getWebinarCategories) {
      this.props.getWebinarCategories().then((res) => {
        console.log("getAllCategories...", res.length);
        var temp = [];
        temp.push({ value: "", label: "All Categories" });
        for (var i = 0; i < res.length; i++) {
          // Updated to use 'Name' property instead of 'CategoryName'
          var obj = { value: res[i].Name, label: res[i].Name };
          temp.push(obj);
        }
        this.setState({ CategorySet: temp });
      }).catch((err) => {
        // If categories API is not available, set some default categories
        console.log("Categories API not available, using defaults");
        this.setState({
          CategorySet: [
            { value: "", label: "All Categories" },
            { value: "Engineering", label: "Engineering" },
            { value: "Technology", label: "Technology" },
            { value: "Management", label: "Management" },
            { value: "Professional Development", label: "Professional Development" },
          ]
        });
      });
    } else {
      // Default categories if the action doesn't exist
      this.setState({
        CategorySet: [
          { value: "", label: "All Categories" },
          { value: "Civil", label: "Civil" },
          { value: "Electrical", label: "Electrical" },
          { value: "Mechanical", label: "Mechanical" },
          { value: "Chemical", label: "Chemical" },
          { value: "Electronics", label: "Electronics" },
          { value: "Metallurgy", label: "Metallurgy" },
          { value: "Agricultural", label: "Agricultural" },
          { value: "Aeronautical", label: "Aeronautical" },
          { value: "Mining", label: "Mining" },
          { value: "Petrogas", label: "Petrogas" },
          { value: "Tele Communication", label: "Tele Communication" },
          { value: "Mechatronics", label: "Mechatronics" },
          { value: "Textile", label: "Textile" },
          { value: "Biomedical", label: "Biomedical" },
          { value: "Engineering Sciences", label: "Engineering Sciences" },
          { value: "Arch Engg", label: "Arch Engg" },
          { value: "Computer", label: "Computer" },
          { value: "Geology", label: "Geology" },
          { value: "Transport", label: "Transport" },
          { value: "Poly", label: "Poly" },
          { value: "Environment", label: "Environment" },
          { value: "Urban", label: "Urban" },
          { value: "Automotive", label: "Automotive" },
          { value: "Energy", label: "Energy" },
          { value: "Management", label: "Management" },
        ]        
      });
    }

    if (this.props.match.params.id == "livewebinar") {
      this.setState(
        { webinartype: "Live Webinar", webinarName: "Live Webinar By PEC" },
        () => {
          this.getCountbyType();
        }
      );
    }
  }

  // New category handler
  handleCategory = (selectedOption) => {
    this.setState({ SelectedCategory: selectedOption }, () => {
      this.applyAllFilters();
    });
  };

  handleInstructor = (selectedOption) => {
    this.setState({ SelectedInstructor: selectedOption }, () => {
      this.applyAllFilters();
    });
  };

  handleChange1 = (event) => {
    this.setState(
      { ...this.state, [event.target.name]: event.target.value },
      () => {
        this.applyAllFilters();
      }
    );
  };

  // New method to apply all filters together
  applyAllFilters = () => {
    let filteredResults = [...this.state.currentSelected];

    // Apply search filter
    if (this.state.search) {
      const searcher = new FuzzySearch(filteredResults, ["Course_Name"], {});
      filteredResults = searcher.search(this.state.search);
    }

    // Apply instructor filter
    if (this.state.SelectedInstructor.value) {
      const searcher = new FuzzySearch(filteredResults, ["FullName"], {});
      filteredResults = searcher.search(this.state.SelectedInstructor.value);
    }

    // Apply category filter
    if (this.state.SelectedCategory.value) {
      // Since category comes as an array with Name property, we need to filter differently
      filteredResults = filteredResults.filter(item => {
        if (item.category && Array.isArray(item.category)) {
          // Check if any category in the array matches the selected category
          return item.category.some(cat => cat.Name === this.state.SelectedCategory.value);
        }
        return false;
      });
    }

    this.setState({ result: filteredResults }, () => {
      this.setElementsForCurrentPage();
    });
  };

  statechange = (event) => {
    this.setState(
      { ...this.state, [event.target.name]: event.target.value },
      () => {
        if (this.state.dateSort == "Earliest") {
          if (this.state.result && this.state.result.length > 0) {
            this.setState(
              { currentSelected: this.state.result.reverse() },
              () => {
                this.setElementsForCurrentPage();
              }
            );
          } else {
            this.setState(
              { currentSelected: this.state.currentSelected.reverse() },
              () => {
                this.setElementsForCurrentPage();
              }
            );
          }
        } else {
          if (this.state.result && this.state.result.length > 0) {
            this.setState(
              { currentSelected: this.state.result.reverse() },
              () => {
                this.setElementsForCurrentPage();
              }
            );
          } else {
            this.setState(
              { currentSelected: this.state.currentSelected.reverse() },
              () => {
                this.setElementsForCurrentPage();
              }
            );
          }
        }
      }
    );
  };

  handlePageClick = (data) => {
    const selectedPage = data.selected;
    const offset = selectedPage * this.state.perPage;
    this.setState({ currentPage: selectedPage, offset: offset }, () => {
      this.getWebinarsbyType();
    });
  };

  setElementsForCurrentPage() {
    if (this.state.result) {
      let elements =
        this.state.result.length > 0 ? (
          this.state.result.map((item, key) => (
            <div className="col-md-4 flex_center newfilxxx" key={key}>
              <Link
                className="co_black"
                to={{
                  pathname: `/LiveWebinar/${item.CourseID}`,
                }}
              >
                <div
                  className="card card_webinar"
                  data-tip={item.Course_Name}
                  style={{ width: "20rem" }}
                >
                  <img
                    src={
                      urlImageUrl +
                      item.Image_URL.slice(0, 7) +
                      "\\" +
                      item.Image_URL.slice(7)
                    }
                    className="card-img-top_webinar"
                    alt="Webinar Featured Image"
                  />
                  <div className="card-body card-bod">
                    <h6 className="card-text-1" style={{ float: "right" }}>
                      <span className="fz_12">CPD Points:</span>{" "}
                      {item.CPDPoints}
                    </h6>
                    <h5 className="bold title">{item.Course_Name}</h5>
                    <h6 className="card-text"> {item.FullName}</h6>
                    {/* Display category if available */}
                    {(item.category && Array.isArray(item.category) && item.category.length > 0) && (
                      <p className="card-text mb_unset fz_12" style={{ color: "#666" }}>
                        <i className="fas fa-tag fa-align-justify i_clock"></i>
                        {item.category.map(cat => cat.Name).join(', ')}
                      </p>
                    )}
                    <i className="fas fa-clock fa-align-justify i_clock"> </i>
                    <p className="card-text mb_unset fz_12">
                      PST&nbsp;
                      <Moment format="hh a">{item.Session_StartDate}</Moment>
                    </p>
                    <i className="far fa-calendar fa-align-justify i_clock "></i>
                    <span className="card-text mb_unset fz_12">
                      {" "}
                      <Moment format="Do-MMM-YYYY">
                        {item.Session_StartDate}
                      </Moment>
                    </span>
                    <div>
                      <i className="fas fa-hourglass-half fa-align-justify i_clock "></i>
                      <p className="card-text mb_unset fz_12">
                        {" "}
                        <Moment
                          duration={item.Session_StartDate}
                          date={item.Session_EndDate}
                        />
                      </p>
                    </div>
                    <p
                      className="card-text mb_unset fz_12"
                      style={{ marginLeft: "1px" }}
                    >
                      <span className="co_green price">
                        {item.pricing_type == "Free"
                          ? "Free"
                          : "Rs " + item.price}{" "}
                      </span>
                    </p>
                  </div>
                </div>
                <ReactTooltip />
              </Link>
            </div>
          ))
        ) : (
          <div className="fs-24 text-center w-100 h-225p ">
            No Results Found.
          </div>
        );
      this.setState({ elements: elements });
    }
  }

  render() {
    let paginationElement;
    if (this.state.result.length > 0 && this.state.pageCount > 1) {
      paginationElement = (
        <ReactPaginate
          previousLabel={"←"}
          nextLabel={"→"}
          breakLabel={<span className="gap">...</span>}
          pageCount={this.state.pageCount}
          onPageChange={this.handlePageClick}
          initialPage={0}
          className={this.state.pageCount === 1 ? "active" : "not active"}
          containerClassName={"pagination"}
          previousLinkClassName={"previous_page"}
          nextLinkClassName={"next_page"}
          disabledClassName={"disabled"}
          activeClassName={"active"}
          activeLinkClassName={"pagination__link--active"}
        />
      );
    }

    return (
      <React.Fragment>
        <section className="backco_white" style={{ fontFamily: "Arial" }}>
          <Header />

          <div className="row col_margin">
            <div className="col-md-3 col_padding" style={{ padding: "2%" }}>
              <CpdActivitiesSIDEbar data={this.state.data} />
            </div>
            <div className="col-md-9 col_padding intr_mr">
              <div id="UpcomingWebinars" className="container tab-pane ">
                <div className="row">
                  <div className="col-md-11">
                    <div className="row col_margin">
                      <div className="col-md-12  mtb_8v">
                        <h3 className="text-left mt-23 bold">
                          {" "}
                          {this.state.webinarName}
                        </h3>
                      </div>
                    </div>
                    
                    {/* Updated filter row with category dropdown */}
                    <div className="row  mtb_8v">
                      <div className="col-md-3">
                        <div className="input-group tm-10 text_border" style={{ marginTop: "47px" }}>
                          <input
                            type="text"
                            className="form-control"
                            style={{ border: "unset" }}
                            placeholder="Search Webinar Here"
                            name="search"
                            onChange={this.handleChange1}
                            value={this.state.search}
                          />
                          <div className="input-group-btn">
                            <button className="btn btn-default" type="submit">
                              <i className="fas fa-search" />
                            </button>
                          </div>
                        </div>
                      </div>
                      
                      {/* Category Filter */}
                      <div className="col-md-2">
                        <h5 className="filter_title tm-5 text-center">
                          Category
                        </h5>
                        <Select
                          className="mtb-10"
                          styles={colourStyles}
                          name="selectedCategory"
                          options={this.state.CategorySet}
                          value={this.state.SelectedCategory}
                          onChange={this.handleCategory}
                          placeholder="Select Category"
                        />
                      </div>
                      
                      {/* Instructor Filter */}
                      <div className="col-md-2">
                        <h5 className="filter_title tm-5 text-center">
                          Instructor
                        </h5>
                        <Select
                          className="mtb-10"
                          styles={colourStyles}
                          name="selectedInstructor"
                          options={this.state.InstructorSet}
                          value={this.state.SelectedInstructor}
                          onChange={this.handleInstructor}
                          placeholder="Select Instructor"
                        />
                      </div>
                      
                      {/* Date Sort */}
                      <div className="col-md-2">
                        <h5 className="filter_title tm-5 text-center">
                          Sort By Date
                        </h5>
                        <div className="tm-10">
                          <select
                            value={this.state.dateSort}
                            onChange={this.statechange}
                            name="dateSort"
                            className="form-control co_black text_border"
                          >
                            <option>By Date </option>
                            <option value="Earliest">Newest Last </option>
                            <option value="Latest">Newest First </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row col_margin mp-8">
                      {this.state.loading == true ? (
                        <div className="loaderDiv text-center">
                          <Loader
                            type="Oval"
                            color="#06580e"
                            height={80}
                            width={80}
                          />
                        </div>
                      ) : (
                        this.state.elements
                      )}
                    </div>
                    {paginationElement}
                  </div>
                  <div className="cold-md-1"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    allWebinars: state.webinarData.publishedWebinars,
  };
}

export default connect(mapStateToProps, {
  getAllPublishedWebinars,
  getWebinarByType,
  getInstructors,
  getWebinarCount,
  // Add this if you create the action
  // getWebinarCategories,
})(WebinarSearch);